import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <section id="home" className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden bg-slate-900">
      
      {/* Background Image with Overlay and Fallback */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://media-manager-c.questera.ai/greta-media/b64cc446cdd47675bdad19de596fda49c979fcc46f742bafa38ab384e40234c3cc3101a26c56d32c5dccb06920b38db8/images/aW1hZ2UvcG5n/31b44c3b26ffafa7066e70c2207c133d.png"
          alt="Tiefbau Hintergrund"
          className="w-full h-full object-cover opacity-80"
          onError={(e) => { 
            // Versteckt das defekte Bild, sodass die saubere bg-slate-900 Farbe bleibt
            e.target.style.opacity = 0; 
          }}
        />
        <div className="absolute inset-0 bg-slate-900/70 mix-blend-multiply" />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/50 via-transparent to-slate-900" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center mt-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <span className="inline-block py-1 px-3 rounded-full bg-amber-500/20 text-amber-400 text-sm font-semibold tracking-wider mb-6 border border-amber-500/30">
            IHR FTTH-AUSBAUPARTNER
          </span>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white tracking-tight mb-6">
            Ganzheitlicher <br className="hidden md:block" />
            <span className="text-amber-500">Glasfasernetzausbau</span>
          </h1>
          <p className="mt-4 max-w-2xl mx-auto text-xl text-slate-300 mb-10">
            Von der Planung über den Tiefbau (NE3) bis zur Inhouse-Installation (NE4). 
            Wir realisieren komplexe Infrastrukturprojekte aus einer Hand.
          </p>
          
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <a href="#services" className="bg-amber-500 hover:bg-amber-600 text-slate-900 px-8 py-3 rounded-md font-bold text-lg transition-all duration-300 shadow-lg shadow-amber-500/30">
              Unsere Leistungen
            </a>
            <a href="#contact" className="bg-transparent hover:bg-white/10 text-white border-2 border-white/30 hover:border-white px-8 py-3 rounded-md font-bold text-lg transition-all duration-300">
              Kontakt aufnehmen
            </a>
          </div>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div 
        animate={{ y: [0, 10, 0] }}
        transition={{ repeat: Infinity, duration: 2 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10"
      >
        <a href="#stats" className="text-white/50 hover:text-white transition-colors">
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
          </svg>
        </a>
      </motion.div>
    </section>
  );
};

export default Hero;